<template>
  <div class="panel" v-if="data">
    <div class="panel-heading">
      <h3 class="panel-title">{{ data.Title }}</h3>
    </div>
    <div class="panel-body">
      <ul class="list-group list-group-dividered list-group-full">
        <li
          v-for="item in data.Items"
          class="list-group-item">
          <small class="pull-right" v-bind:class="item.Label.ValueClass">{{ item.Label.Value }}</small>
          <p>{{ item.Text }}</p>
          <small
            @click="click(item)"
            v-bind:class="{linked: item.hasOwnProperty('id')}"
          >
            {{ item.Text2 }}
          </small>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name:  'TicketsPanel',
  props: ['item'],
  data () {
    return {
      data: {}
    }
  },

  created () {
    this.data = JSON.parse(this.item.FieldValues[0].JSON)
  },

  methods: {
    click (item) {
      if (!item.hasOwnProperty('id')) {
        return
      }

      this.$router.push({
        name:   'PageDynamicEditor',
        params: { page: item.tEntityCode, idStructure: '0', id: item.id, redir: 'grid' }
      })
    }
  }
}
</script>

<style scoped>
small.linked {
  cursor: pointer;
}
</style>
